const KeyMirror = require("keymirror");

module.exports = KeyMirror({
    GIFT_CREDITS_BEGIN: true,
    GIFT_CREDITS_SUCCESS: true,
    GIFT_CREDITS_FAILURE: true
});



// WEBPACK FOOTER //
// ./src/action-types/giftcredits.js